var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// AdornisFilter.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { AbstractAspect } from "./aspect-schemas/AbstractAspect.js";
var AdornisFilter = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
  /** get the mongo filter defined by this filter instance. This can be used by any mongo find operation */
  getMongoFilter() {
    const selector = { $and: [] };
    for (const aspect of this.aspects) {
      const filter = aspect.getMongoFilter();
      if (filter)
        selector.$and.push(filter);
    }
    if (this.search && this.searchFields) {
      selector.$and.push({
        $or: this.searchFields.map((searchField) => ({
          // this.search cannot be undefined here as array.prototype.map gets called synchronously, so there is no possibility to manipulate the search after the if check above
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          [searchField]: { $regex: this.search.replace(/([^a-zA-Z0-9\s])/g, "\\$1"), $options: "i" }
        }))
      });
    }
    return !selector.$and.length ? {} : selector;
  }
  /** get the mongo options defined by this filter instance. This can be used as the options of any mongo find operation */
  getMongoOptions() {
    const obj = this.toObject();
    const sort = {};
    if (obj.sortingFields && obj.sortingDirections) {
      for (let i = 0; i < obj.sortingFields.length; i++) {
        sort[obj.sortingFields[i]] = obj.sortingDirections[i] === "asc" ? 1 : -1;
      }
    }
    return { sort };
  }
  /** set a new `FilterAspect`. If any `FilterAspect` for the given field already exists, it is overwritten */
  setFilterAspect(comparison) {
    let existingIndex = this.aspects.findIndex(
      (c) => c.customID && c.customID === comparison.customID || !c.customID && c.fieldName === comparison.fieldName
    );
    if (existingIndex === -1) {
      this.aspects.push(comparison);
    } else {
      this.aspects.splice(existingIndex, 1, comparison);
    }
  }
  getFilterAspect(fieldNameOrCustomID) {
    if (!fieldNameOrCustomID)
      return null;
    return this.aspects.find(
      (c) => c.customID && c.customID === fieldNameOrCustomID || !c.customID && c.fieldName === fieldNameOrCustomID
    );
  }
  removeFilterAspect(fieldNameOrCustomID) {
    if (!fieldNameOrCustomID)
      return null;
    const index = this.aspects.findIndex(
      (c) => c.customID && c.customID === fieldNameOrCustomID || !c.customID && c.fieldName === fieldNameOrCustomID
    );
    if (index !== -1) {
      return this.aspects.splice(index, 1)[0];
    }
    return null;
  }
  _safeRegex(regex) {
    return regex.replaceAll(/([^\w])/g, "\\$1");
  }
};
AdornisFilter._class = "AdornisFilter";
__decorateClass([
  Field((type) => String)
], AdornisFilter.prototype, "search", 2);
__decorateClass([
  Field((type) => [String])
], AdornisFilter.prototype, "searchFields", 2);
__decorateClass([
  Field((type) => [String], { default: (v) => v ?? ["_id"] })
], AdornisFilter.prototype, "sortingFields", 2);
__decorateClass([
  Field((type) => [String], { default: (v) => v ?? ["desc"] })
], AdornisFilter.prototype, "sortingDirections", 2);
__decorateClass([
  Field((type) => [AbstractAspect], { default: (v) => v ?? [] })
], AdornisFilter.prototype, "aspects", 2);
AdornisFilter = __decorateClass([
  Entity()
], AdornisFilter);
export {
  AdornisFilter
};
